<template>
      <v-container fluid>
      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
        <v-card outlined :loading="loading">
              <v-card>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Create your <span class="hidden-xs-only">Pappyon</span> account</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="registerUser"
                >
                  <v-card-text>
                      <v-alert
                        text
                        prominent
                        color="primary"
                        icon="priority_high"
                        v-if="error!=''"
                      >
                        <v-row align="center" no-gutters>
                          <v-col class="grow">{{error}}</v-col>
                        </v-row>
                      </v-alert>
                      <v-text-field
                        label="Email"
                        :readonly="isEmailReadOnly"
                        name="email"
                        outlined
                        type="text"
                        v-model="email"
                        dense
                        :validate-on-blur="isFirstSubmissionAttempt"
                        :rules="emailRules"
                      ></v-text-field>
                      <v-row>
                        <v-col cols="12" md="6" class="my-0 py-0">
                          <v-text-field
                            label="First Name"
                            :readonly="isFirstNameReadOnly"
                            name="firstName"
                            outlined
                            type="text"
                            v-model="firstName"
                            dense
                            :validate-on-blur="isFirstSubmissionAttempt"
                            :rules="nameRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6"  class="my-0 py-0">
                          <v-text-field
                            label="Last Name"
                            :readonly="isLastNameReadOnly"
                            name="lastName"
                            outlined
                            type="text"
                            v-model="lastName"
                            dense
                            :validate-on-blur="isFirstSubmissionAttempt"
                            :rules="nameRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-text-field
                        ref="password"
                        id="password"
                        label="Password"
                        name="password"
                        outlined
                        v-model="password"
                        dense
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        hint="At least 8 characters"
                        counter
                        @click:append="show1 = !show1"
                        :validate-on-blur="isFirstSubmissionAttempt"
                        :rules="passwordRules"
                      ></v-text-field>
                      <v-text-field
                        id="confirmPassword"
                        label="Confirm Password"
                        name="confirmPassword"
                        outlined
                        v-model="confirmPassword"
                        dense
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show2 ? 'text' : 'password'"
                        counter
                        @click:append="show2 = !show2"
                        :rules="[() => password == confirmPassword || 'The passwords don\'t match', v => !!v || 'Please retype your password']"
                      ></v-text-field>
                      <v-row align="center" no-gutters>
                        <v-col class="grow">
                          <div class="text-center text-body-2 grey--text">By continuing you agree to the <br>Pappyon <a class="grey--text text--darken-1 font-weight-bold text-decoration-none" @click="openTermsOfUseUrl()">Terms of Use</a>  and <a class="grey--text text--darken-1 font-weight-bold text-decoration-none" @click="openPrivacyPolicyUrl()">Privacy Policy</a></div>
                        </v-col>
                      </v-row>
                      
                  </v-card-text>
                  <v-card-actions class="px-4 pt-2">
                      <v-btn elevation="0" block type="submit" color="primary" large class="px-5 mb-3 text-body-2">Agree and Sign Up</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
        </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-8">
            <v-spacer></v-spacer>
              <div class="text-center text-body-1 grey--text">Have an account? <router-link :to="logInLink()" class="text-decoration-none font-weight-medium"><span>Log In</span></router-link></div>
            <v-spacer>
            </v-spacer>
          </v-row>
      </v-container>
</template>
<script>
// @ is an alias to /src

import { mapGetters } from 'vuex';
import Utility from '@/shared/utility';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import {
  getAuth,
  getDocRef,
  getQueryBusinessPortalAccessCollection,
  setUsersDoc, updateBusinessPortalAccessDoc,
  updateDocByName
} from "@/shared/firebase_utils";
import {where} from "firebase/firestore";

export default {
  name: 'Register',
  data() {
    return{
      email: '',
      isEmailReadOnly: false,
      firstName: '',
      isFirstNameReadOnly: false,
      lastName: '',
      isLastNameReadOnly: false,
      password: '',
      confirmPassword: '',
      error: '',
      loading: false,
      show1: false,
      show2: false,
      valid: false,
      isFirstSubmissionAttempt: true,
      emailRules: [
        v => !!v || 'Please enter your email',
        v => /.+@.+\..+/.test(v) || 'Invalid email',
      ],
      nameRules: [
        v => !!v || 'This field is required',
      ],
      passwordRules: [
        v => !!v || 'Please enter your password',
        v => v.length >= 8 || 'The password must be at least 8 characters long',
      ],
      isPartnerRepresentativeDocExists: false,
      promoterType: '',
    };
  },
  created() {
    this.openTermsOfUseUrl = Utility.openTermsOfUseUrl;
    this.openPrivacyPolicyUrl = Utility.openPrivacyPolicyUrl;
    this.getSubscriptionPlanFromQueryString = Utility.getSubscriptionPlanFromQueryString;
    this.getPartnerRepresentativeToken();
  },
  methods: {
    async getPartnerRepresentativeToken() {
      if(this.$route.query.partnerRepresentativeToken != undefined) {
        this.promoterType = this.$route.query.promoterType ?? 'Partner';
        let collectionName = this.promoterType == 'STARTUPS_AND_SCALE_UPS' ? 'featuredCompanies' : 'sponsors';

        let partnerRepresentativeTokenDocRef = getDocRef(collectionName, this.$route.query.partnerRepresentativeToken);
        let partnerRepresentativeTokenDoc = await partnerRepresentativeTokenDocRef.get();
        if(partnerRepresentativeTokenDoc.exists) {
          this.isPartnerRepresentativeDocExists = true;
          //If the email firstName and lastName exists on the partnerRepresentativeTokenDoc then set the email firstName and lastName to the values from the partnerRepresentativeTokenDoc
          if(partnerRepresentativeTokenDoc.data().email != undefined) {
            this.email = partnerRepresentativeTokenDoc.data().email;
            this.isEmailReadOnly = true;
          }
          if(partnerRepresentativeTokenDoc.data().firstName != undefined) {
            this.firstName = partnerRepresentativeTokenDoc.data().firstName;
            this.isFirstNameReadOnly = true;
          }
          if(partnerRepresentativeTokenDoc.data().lastName != undefined) {
            this.lastName = partnerRepresentativeTokenDoc.data().lastName;
            this.isLastNameReadOnly = true;
          }
          this.$refs.password.focus();
        }
      }
    },
    async  registerUser() {
       if (this.$refs.form.validate()) {
          try {

            const auth = getAuth();
            //Start: Register user using firebase auth
            this.loading = true;
            
            let userCredential = await createUserWithEmailAndPassword(auth, this.email,this.password);
            let newlyRegisteredUser = userCredential.user;
            console.log('The user was registered successfully');
            //End: Register user using firebase auth
            //Start: Add an new user document in firestore

            await setUsersDoc(newlyRegisteredUser.uid, {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              creationDate: new Date(),
              lastLoginDate: new Date(),
              lastLoggedInPlatform: 'business-portal',
              hasLoggedInToBusinessPortal: true,
              subscriptionPreference: this.getSubscriptionPlanFromQueryString(this.$route.query.plan ?? ''),
              partnerRepresentativeToken: this.$route.query.partnerRepresentativeToken ?? null,
              promoterType: this.promoterType,
            });

            
            //End: Add an new user document in firestore

            let collectionName = this.promoterType == 'STARTUPS_AND_SCALE_UPS' ? 'featuredCompanies' : 'sponsors';

            if (this.isPartnerRepresentativeDocExists) {
              await updateDocByName(collectionName, this.$route.query.partnerRepresentativeToken, {
                status: 'Registered',
              });
            }
            //Start: Attach any business portal access permissions that have the same email as the newly registered user 
            let usersBusinessPortalAccessPermissions = await getQueryBusinessPortalAccessCollection(where('email', '==', newlyRegisteredUser.email.toLowerCase()), where('status', '==', 'invited'));
            //Iterate through each element in usersBusinessPortalAccessPermissions.docs array in parallel 
            //but await the async processing of each element in the usersBusinessPortalAccessPermissions.docs array
            await Promise.all(usersBusinessPortalAccessPermissions.docs.map(async (businessPortalAccessDocRef) => {
              //Update the uid of every business portal access document and update their status to active
              await updateBusinessPortalAccessDoc(businessPortalAccessDocRef.ref.id, {
                uid: newlyRegisteredUser.uid,
                status: 'active',
              });
            }));
            //End: Attach any business portal access permissions that have the same email as the newly registered user 
            if(usersBusinessPortalAccessPermissions.empty) {
              //The user does not have any businesss portal access permissions

            }
            this.$router.push('/businessAccounts');
          } catch(err) {
            this.error = err.message;
            this.loading = false;
          }
      } else {
        this.isFirstSubmissionAttempt = false;
        this.error=''
      }
    },
    logInLink() {
      if (this.$route.query.plan != undefined)
        return '/login?plan=' + this.$route.query.plan;
      else
        return '/login';
    },
   
  },
  computed: {
      ...mapGetters(['termsOfUseUrl', 'privacyPolicyUrl']),
      passwordConfirmationRule() {
        return () => (this.password === this.confirmPassword) || 'Password must match'
      },
  }
}
</script>